import api from '../../plugins/api';

// GET /api/shop/getStockFilters â Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð² ÑÑÐ¾ÐºÐ° Ð¸ ÑÐ¸ÑÐ»Ð¾ Ð¼Ð°ÑÐ¸Ð½ Ð¿Ð¾Ð´ ÐºÐ°Ð¶Ð´ÑÐ¼.
// ÐÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐµ Ð¶Ðµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ, ÑÑÐ¾ Ð¸ getItems: Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ ÑÐ¸Ð»ÑÑÑÑ ÑÑÐ¶Ð°ÑÑ ÑÐ¿Ð¸ÑÐºÐ¸ Ð´ÑÑÐ³ Ð´ÑÑÐ³Ð°.
const getStockFilters = (params) => {
  return api.get('/api/shop/getStockFilters', params);
};

export default getStockFilters;
